function _instanceof(left, right) {
    "@swc/helpers - instanceof";
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
/**
    ES5 implementation to reduce an Array of values to unique instances.
    @param arr The Array of objects to be filtered.
    @param accessor An optional accessor function used to extract data points from an Array of Objects.
    @example <caption>this</caption>
unique(["apple", "banana", "apple"]);
    @example <caption>returns this</caption>
["apple", "banana"]
*/ export default function(arr) {
    var accessor = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function(d) {
        return d;
    };
    var values = arr.map(accessor).map(function(d) {
        return _instanceof(d, Date) ? +d : d;
    });
    return arr.filter(function(obj, i) {
        var d = accessor(obj);
        return values.indexOf(_instanceof(d, Date) ? +d : d) === i;
    });
}

//# sourceMappingURL=unique.js.map